module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAABaCAYAAACbgCfEAAAAAXNSR0IArs4c6QAAAStJREFUSA3tlr1Ow0AQhG+dUyR+CoSEREUVyW/Fa7i7whW8xr1TJFtKRYWEhChCUoVl5sjCJoRUxJWvufXn8ezpPPJZVHXa932L+T5giEiu6zpJ13UPgA2hDdx8rExpkDNZ5YGvK3p6wJpM8NjB5vvi8XqQHRCdz6eLzaaVICUMGjTPJpMUCYOGBsBW0oCFypRGOZP9HQZ6ejVrsshG9DRLa74vHq8H2YEShqfVukW3EgbM+e78LEVCRRjcMhqwwHduSncvHAkDPb10W+fIRvTEMMvS/IB4RKffgRKGl7clPgJfxwS+3/nm6jJFQtWPnzDgyABDGEzpV3f0mKCnF5caLLIRPb8tt81/iUcwxA6UMLw/v+6E4eL2OkXCnX8GhAHsX8PARvT0YSD7BEzoo/fFsm1/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico/v-dot.png
// module id = O8ep
// module chunks = 2